import { Box, Typography } from "@mui/material";

export default function ContatoCamara() {
  return (
    <Box sx={{ p: 2 }}>
      {/* Sede */}
      <Box mb={2}>
        <Typography variant="h6" fontWeight={700}>Câmara Municipal - Sede</Typography>
        <Typography>Al. Dr. Gabriel Avair, 58, Centro</Typography>
        <Typography>São Lourenço/MG</Typography>
        <Typography>CEP: 37.470-000</Typography>
        <Typography>Tel.: (35) 3332-2001</Typography>
      </Box>

      {/* Anexo */}
      <Box mb={2}>
        <Typography variant="h6" fontWeight={700}>Câmara Municipal - Anexo</Typography>
        <Typography>Av. Comendador Costa, 107, Centro</Typography>
        <Typography>São Lourenço/MG</Typography>
        <Typography>CEP: 37.470-000</Typography>
        <Typography>Tel.: (35) 3332-6847</Typography>
      </Box>

      {/* Contato */}
      <Box>
        <Typography variant="h6" fontWeight={700}>Contato</Typography>
        <Typography>escoladolegislativo@camarasl.mg.gov.br</Typography>
      </Box>
    </Box>
  );
}
